<template>
  <v-container class="pa-0">
    <ValidationObserver ref="validateObserver" v-slot="{ invalid }">
      <v-row dense>
        <v-col>
          <form autocomplete="off">
            <v-row dense>
              <v-col>
                <mb-input-text
                  v-model="dependent.name"
                  name="dep_name"
                  label="Nome Completo"
                  rules="required"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col xl="4" lg="4" md="4" sm="4" cols="12">
                <mb-date
                  v-model="dependent.birthdate"
                  name="dep_birthdate"
                  label="Nascimento"
                  rules="required"
                  :allowedDates="(vl) => { return $moment(vl).isBefore($moment()) }"
                />
              </v-col>
              <v-col xl="4" lg="4" md="4" sm="4" cols="12">
                <mb-select
                  v-model="dependent.kinshipId"
                  :items="kinships"
                  itemText="name"
                  itemValue="id"
                  name="dep_kinship"
                  label="Parentesco"
                  rules="required"
                />
              </v-col>
              <v-col xl="4" lg="4" md="4" sm="4" cols="12">
                <mb-select
                  v-model="dependent.genre"
                  :items="sexItems"
                  itemText="text"
                  itemValue="vl"
                  name="sex"
                  label="Sexo"
                  rules="required"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <mb-input-text
                  v-model="dependent.email"
                  type="email"
                  name="dep_email"
                  label="Email"
                  rules="email"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col xl="4" lg="4" md="4" sm="4" cols="12">
                <mb-input-cpf
                  v-model="dependent.cpf"
                  name="cpf"
                  label="CPF"
                />
              </v-col>
              <v-col xl="4" lg="4" md="4" sm="4" cols="12">
                <mb-input-phone
                  v-model="dependent.phones.home"
                  name="dep_phone_home"
                  label="Telefone"
                />
              </v-col>
              <v-col xl="4" lg="4" md="4" sm="4" cols="12">
                <mb-input-phone
                  v-model="dependent.phones.mobile"
                  name="dep_phone_mobile"
                  label="Celular"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <mb-text-button name="dep_cancel" label="Cancelar"
                  @click="cancel" :primary="false" />
              </v-col>
              <v-col class="pb-5" align="right"
                xl="4" lg="4" md="4" sm="4" cols="12"
                :order="($vuetify.breakpoint.xsOnly) ? 'first' : 'last'"
              >
                <mb-text-button name="dep_save" label="Salvar"
                  :disabled="invalid"
                  :loading="saveBtnLoading"
                  @click="(dependent.id) ? update() : create()"
                />
              </v-col>
            </v-row>
          </form>
        </v-col>
      </v-row>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import bus from '@/plugins/eventBus';
import MbInputText from '@/components/general/inputs/MbInputText';
import MbInputPhone from '@/components/general/inputs/MbInputPhone';
import MbSelect from '@/components/general/inputs/MbSelect';
import MbTextButton from '@/components/general/buttons/MbTextButton';
import MbDate from '@/components/general/inputs/MbDate';
import MbInputCpf from '@/components/general/inputs/MbInputCpf';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    dependent: {
      id: null,
      patientId: null,
      name: null,
      birthdate: null,
      kinshipId: null,
      genre: null,
      email: null,
      phones: {
        home: null,
        mobile: null,
      },
      cpf: null,
    },
    sexItems: [
      { vl: 'female', text: 'Feminino' },
      { vl: 'male', text: 'Masculino' },
    ],
    kinships: [],
    saveBtnLoading: false,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.getKinships();

    if (this.value) {
      Object.keys(this.value)
        .filter(key => key in this.dependent)
        .forEach((key) => {
          this.dependent[key] = this.value[key];
        });
      this.setPhones(this.value.phones);
    }

    this.dependent.patientId = this.user.id;
  },
  methods: {
    save() {
      if (this.dependent.id) {
        this.update();
      } else {
        this.save();
      }
    },
    async create() {
      const isValid = await this.$refs.validateObserver.validate();
      if (isValid) {
        this.saveBtnLoading = true;

        const newDependent = JSON.parse(JSON.stringify(this.dependent));
        delete newDependent.id;

        this.$store
          .dispatch('patientDependents/create', newDependent)
          .then((dependentSaved) => {
            this.dependent.id = dependentSaved.id;
            this.$emit('input', this.dependent);
            bus.$emit('message', {
              message: 'Dependente criado com sucesso!',
              type: 'success',
            });
          })
          .catch((err) => {
            bus.$emit('message', {
              message: err.response.data.message,
              type: 'error',
            });
          })
          .finally(() => {
            this.saveBtnLoading = false;
          });
      }
    },
    async update() {
      const isValid = await this.$refs.validateObserver.validate();
      if (isValid) {
        this.updateBtnLoading = true;

        const dependentUpdated = JSON.parse(JSON.stringify(this.dependent));

        this.$store
          .dispatch('patientDependents/update', dependentUpdated)
          .then(() => {
            bus.$emit('message', {
              message: 'Dependente atualizado com sucesso!',
              type: 'success',
            });
          })
          .catch((err) => {
            bus.$emit('message', {
              message: err.response.data.message,
              type: 'error',
            });
          })
          .finally(() => {
            this.saveBtnLoading = false;
          });
      }
    },
    getKinships() {
      this.$store.dispatch('kinship/get').then((kinships) => {
        this.kinships = kinships;
      });
    },
    cancel() {
      this.$router.push('/dependents/list');
    },
    setPhones(phones) {
      if (typeof phones === 'string') {
        const phonesObj = JSON.parse(phones);
        this.dependent.phones = { home: null, mobile: null };
        this.dependent.phones.home = phonesObj.home || null;
        this.dependent.phones.mobile = phonesObj.mobile || null;
      }
    },
  },
  watch: {
    value(vl) {
      if (vl) {
        Object.keys(vl)
          .filter(key => key in this.dependent)
          .forEach((key) => {
            this.dependent[key] = vl[key];
          });

        this.setPhones(vl.phones);
      }
    },
  },
  components: {
    ValidationObserver,
    MbInputText,
    MbInputPhone,
    MbSelect,
    MbTextButton,
    MbDate,
    MbInputCpf,
  },
};
</script>
